<template>
  <div>
    <div class="emd-tabbar jsTabbar _bordered">
      <ul class="emd-tabbar__list">
        <li class="emd-tabbar__item">
          <a
            class="emd-tabbar__link"
            v-on:click="changeTab('info')"
            v-bind:class="{ _active: tabActive === 'info' }"
          >
            <span class="emd-text">{{
              $t('subscription.detail.tab-info')
            }}</span>
          </a>
        </li>
        <li
          class="emd-tabbar__item"
          v-if="permissionIsEnabled('invoice:search')"
        >
          <a
            class="emd-tabbar__link"
            v-on:click="changeTab('invoices')"
            v-bind:class="{ _active: tabActive === 'invoices' }"
          >
            <span class="emd-text">{{
              $t('subscription.detail.tab-invoices')
            }}</span>
          </a>
        </li>
      </ul>
    </div>
    <subscription-info v-if="tabActive === 'info'"></subscription-info>
    <subscription-invoices
      v-if="tabActive === 'invoices'"
    ></subscription-invoices>

    <last-log></last-log>
  </div>
</template>

<script>
import SubscriptionInfo from '@/views/Recurrences/Subscriptions/SubscriptionsDetail/SubscriptionInfo.vue'
import SubscriptionInvoices from '@/views/Recurrences/Subscriptions/SubscriptionsDetail/SubscriptionInvoices.vue'
import LastLog from '@/components/project/molecules/LastLog.vue'
export default {
  components: {
    SubscriptionInfo,
    SubscriptionInvoices,
    LastLog
  },
  data () {
    return {
      tabActive: 'info'
    }
  },
  methods: {
    changeTab (tab) {
      this.tabActive = tab
      this.$router
        .push({ name: 'subscriptionsDetail', params: { tab: tab } })
        .catch(err => err)
    },
    permissionIsEnabled (action) {
      return this.$store.getters.permissionIsEnabled(action)
    }
  },
  computed: {
    params () {
      return {
        merchantId: this.$store.getters.merchantId,
        accountId: this.$store.getters.accountId,
        entityId: this.$route.params.id
      }
    }
  },
  created () {
    this.tabActive = this.$route.params.tab
    this.$store.dispatch('GET_LAST_LOG', this.params)
  },
  mounted () {
    if (!this.$route.params.id.includes('sub_')) {
      this.$router.push({ name: 'subscriptions' }).catch(err => err)
    }
  }
}
</script>
